import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { toast } from 'react-toastify';
const mapStateToProps = (state) => {
  return {
    feedback: state.feedback
  };
};
const mapDispatchToProps = {};

function FeedbackToast ({ feedback }) {
  useEffect(() => {
    if (feedback.message) {
      toast(feedback.message, {
        type: feedback.type,
        autoClose: 1000,
        hideProgressBar: true,
        position: 'top-right',
        theme: 'colored'
      });
    }
  }, [feedback]);
  return <></>;
}

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackToast);
